<!--
 * @Author:
 * @LastEditTime: 2024-10-17 10:28:10
 * @Description:
-->
<template>
  <CockpitDialog title="查看" @close="$emit('close')" class="left-420px top-180px">
    <el-row class="h-full">
      <el-col :span="24" class="h-full cursor-default">
        <div class="w-full h-36px flex" v-if="false">
          <span class="w-135px text-hex-ffffffcc text-right">巡检点名称：</span>
          <el-tooltip effect="light" :content="detailDialogData.deviceName" placement="top">
            <span class="text-white truncate">{{ detailDialogData.deviceName }}</span>
          </el-tooltip>
        </div>
        <div class="w-full h-36px flex" v-if="detailDialogData.deviceName">
          <span class="w-135px text-hex-ffffffcc text-right">巡检对象名称：</span>
          <el-tooltip effect="light" :content="detailDialogData.deviceName" placement="top">
            <span class="text-white truncate">{{ detailDialogData.deviceName }}</span>
          </el-tooltip>
        </div>
        <div class="w-full h-36px flex">
          <span class="w-135px text-hex-ffffffcc text-right">采集时间：</span>
          <span class="text-white truncate">{{ detailDialogData.createTime }}</span>
        </div>
        <div class="w-full h-36px flex">
          <span class="w-135px text-hex-ffffffcc text-right">告警等级：</span>
          <span class="text-white truncate">{{ detailDialogData.alarmLevel }}</span>
        </div>
        <div class="w-full h-96px flex">
          <span class="w-135px text-hex-ffffffcc text-right">告警内容：</span>
          <el-tooltip effect="light" :content="detailDialogData.alarmContent" placement="top">
            <p class="h-full text-base text-white diy-truncate-4">
              {{ detailDialogData.alarmContent }}
            </p>
          </el-tooltip>
        </div>
      </el-col>
      <!-- <el-col :span="15" class="h-full">
        <img :src="imgUrl" class="h-full w-full" />
      </el-col> -->
    </el-row>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import dayjs from 'dayjs'

export default {
  name: 'DialogViewDetail',
  components: { CockpitDialog },
  props: {
    detailData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      detailDialogData: {},
      imgUrl: require('../../image/IntelligentPowerGenerationImg/smartMonitoringImg.png'),
    }
  },
  watch: {},
  created() {
    this.detailDialogData = this.detailData
    this.imgUrl =
      this.detailDialogData.ip && this.detailDialogData.picturePath
        ? `http://${this.detailDialogData.ip}${this.detailDialogData.picturePath}`.replace(/%/g, '%25').replace(/#/g, '%23').replace(/\?/g, '%3F')
        : this.imgUrl
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-truncate-4 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 4;
  text-overflow: ellipsis;
}
</style>
